@if (imageDataUri) {
  <img [src]="imageDataUri" alt="" class="qr-code">
}
